import styled from 'styled-components';

export const ClientSingleApplicationPageContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;
